var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.72 476.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-7, .cls-8 {\n        fill: none;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 225.72,
    height: 476.51
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 124.94,
    y1: 392.58,
    x2: 124.94,
    y2: 195.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8eb30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f4e933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e9e63c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#d6e04c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#bcd762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9acc7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#71bfa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#41b0ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#28a8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3390d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4e5cad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5e3c97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#65308f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 126.07,
    y1: 383.33,
    x2: 126.07,
    y2: 185.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 127.2,
    y1: 374.08,
    x2: 127.2,
    y2: 176.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 128.34,
    y1: 364.83,
    x2: 128.34,
    y2: 167.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 129.47,
    y1: 355.58,
    x2: 129.47,
    y2: 158.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 130.6,
    y1: 346.34,
    x2: 130.6,
    y2: 148.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 131.73,
    y1: 337.09,
    x2: 131.73,
    y2: 139.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 132.87,
    y1: 327.84,
    x2: 132.87,
    y2: 130.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 134,
    y1: 318.59,
    x2: 134,
    y2: 121.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 135.13,
    y1: 309.35,
    x2: 135.13,
    y2: 111.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 136.27,
    y1: 300.1,
    x2: 136.27,
    y2: 102.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 137.4,
    y1: 290.85,
    x2: 137.4,
    y2: 93.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 138.53,
    y1: 281.6,
    x2: 138.53,
    y2: 84.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 139.67,
    y1: 272.35,
    x2: 139.67,
    y2: 74.83,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m-61.9,195.27l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95c-91.62-29.46-389.44-130.67-375.16-196.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m-60.77,186.02l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95c-91.62-29.46-389.44-130.67-375.16-196.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m-59.63,176.77l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95c-91.62-29.46-389.44-130.67-375.16-196.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m-58.5,167.52l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95c-91.62-29.46-389.44-130.67-375.16-196.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m-57.37,158.28l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95c-91.62-29.46-389.44-130.67-375.16-196.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m-56.23,149.03l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95c-91.62-29.46-389.44-130.67-375.16-196.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m-55.1,139.78l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95c-91.62-29.46-389.44-130.67-375.16-196.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m-53.97,130.53l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95c-91.62-29.46-389.44-130.67-375.16-196.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m-52.83,121.28l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95C230.71,288.18-67.11,186.97-52.83,121.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m-51.7,112.04l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95C231.84,278.94-65.97,177.72-51.7,112.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m-50.57,102.79l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95C232.98,269.69-64.84,168.47-50.57,102.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m-49.44,93.54l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95C234.11,260.44-63.71,159.23-49.44,93.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m-48.3,84.29l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95C235.24,251.19-62.58,149.98-48.3,84.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m-47.17,75.04l-.98-.21c-6.45,29.68,47.49,69.41,160.31,118.09,80.13,34.58,169.43,64.61,215.52,79.43l.31-.95C236.38,241.95-61.44,140.73-47.17,75.04Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImg3);
export default __webpack_public_path__ + "static/media/bg-img-3.603d778faac04d1dea1d23c638a0e5d7.svg";
export { ForwardRef as ReactComponent };